<template>
  <v-dialog
      v-model="show"
      :max-width="'450px'"
      persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Fahrzeuge/Geräte wählen</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-row style="margin: 0">
              <v-text-field
                  v-model="search_fahr"
                  prepend-icon="mdi-magnify"
                  label="Suchen"
                  single-line
                  hide-details
                  clearable
              ></v-text-field>
            </v-row>
            <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
            >
              <v-list-item-group
                  v-model="selectedFahrs"
                  multiple
                  color="indigo"
              >
                <template v-for="(group, i) in myList">
                  <v-divider v-if="group.title" style="border-color: rgba(0,0,0,0.46)"></v-divider>
                  <v-subheader v-if="group.title" style="margin-left: -16px">{{ group.title }}</v-subheader>
                  <v-list-item
                      v-for="(item, i) in group.items"
                      :key="item.access"
                      :value="item.access"
                      :style="{
                        'border-bottom': i === group.items.length - 1 ? 'none': 'rgba(128,128,128,0.25) thin solid',
                      }"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            v-on:click.stop="show = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="selectedFahrs.length === 0"
            v-on:click.stop="sendResult"
        >
          Auswählen
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
        v-model="showDuration"
        :max-width="'500px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Dauer wählen</span>
        </v-card-title>
        <v-card-text>
          <v-time-picker
              v-model="currentDuration"
              format="24hr"
              :max="duration"
              landscape
          ></v-time-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="cancelDuration"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="timeRegex.test(currentDuration) === false || currentDuration > duration"
              v-on:click.stop="saveDuration"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>

</template>

<script>


export default {
  name: "SelectFahrDialog",
  props: {
    fahrs: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    leist: {
      type: String,
      default: () => ''
    },
    leistMapping: {
      type: Array,
      default: () => []
    },
    duration: {
      type: String,
      default: () => '04:30'
    },
    specialCarModule: {
      type: Boolean,
      default: () => false
    },
  },
  computed: {
    currentLeistMapping() {
      if (!this.leistMapping || this.leistMapping.length === 0 || !this.leist) {
        return [];
      }
      // filter leistMapping for current leist
      return this.leistMapping.filter(lm => lm.key === this.leist);
    },
    myList() {
      // first apply the search filter
      let filtered = [...this.fahrs];
      if (this.search_fahr && this.search_fahr.length > 0) {
        const search = this.search_fahr.toLowerCase();
        filtered = filtered.filter(fahr => fahr.name.toLowerCase().includes(search));
      }
      let preselect = {
        title: 'Vorauswahl',
        items: []
      }
      let rest = {
        title: 'Weitere Fahrzeuge/Geräte',
        items: []
      }
      let list = [];
      let cats = this.categories || [];
      for (let i = 0; i < filtered.length; i++) {
        let cur = filtered[i];
        let leistIndex = this.currentLeistMapping.findIndex(lm => lm.value === cur.access);
        let catIndex = cats.findIndex(cat => cat.value === cur.access);
        // first check if in currentLeistMapping
        if (leistIndex !== -1) {
          preselect.items.push(cur);
        } else if (catIndex !== -1) {
          let cat = cats[catIndex];
          let catListIndex = list.findIndex(l => l.title === cat.key);
          if (catListIndex === -1) {
            list.push({
              title: cat.key,
              items: [cur]
            });
          } else {
            list[catListIndex].items.push(cur);
          }
        } else {
          rest.items.push(cur);
        }
      }
      // order list by text
      list.sort((a, b) => a.title.localeCompare(b.title));
      // prepend preselect and append rest
      if (preselect.items.length > 0) {
        list.unshift(preselect);
      }
      if (list.length === 0) {
        rest.title = '';
      }
      if (rest.items.length > 0) {
        list.push(rest);
      }
      return list;
    },
    demoList() {
      return {
        'Test': this.fahrs,
      }
    }
  },
  watch: {
    selectedFahrs(newVal, oldVal) {
      // check if we have deletion or addition
      if (newVal.length < oldVal.length) {
        // deletion
        let deleted = oldVal.filter(x => !newVal.includes(x));
        for (let i = 0; i < deleted.length; i++) {
          delete this.durations[deleted[i]];
        }
      } else {
        // addition
        let added = newVal.filter(x => !oldVal.includes(x));
        for (let i = 0; i < added.length; i++) {
          this.currentAddition = added[i];
          this.currentDuration = this.duration;
          if (this.specialCarModule) {
            this.showDuration = true;
          } else {
            this.durations[this.currentAddition] = this.currentDuration;
          }
          break;
        }
      }
    }
  },

  data: () => ({
    selectedFahrs: [],
    show: false,
    search_fahr: '',
    headerFahrs: [
      { text: '', value: 'name' },
    ],
    currentAddition: null,
    showDuration: false,
    currentDuration: '',
    durations: {},
    timeRegex: /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/,
  }),
  methods: {
    openDialog() {
      this.selectedFahrs = [];
      this.show = true;
    },
    getItemClass(item) {
      if (this.selectedFahrs.indexOf(item.access) > -1) {
        return 'row-focused';
      }
      return '';
    },
    onSelect(item) {
        if (this.selectedFahrs.indexOf(item.access) > -1) {
          const index = this.selectedFahrs.indexOf(item.access);
          this.selectedFahrs.splice(index, 1);
        } else {
          this.selectedFahrs.push(item.access);
        }
    },
    saveDuration() {
      this.durations[this.currentAddition] = this.currentDuration;
      this.showDuration = false;
    },
    cancelDuration() {
      // remove from selectedArtis
      let index = this.selectedFahrs.findIndex(a => a === this.currentAddition);
      if (index !== -1) {
        this.selectedFahrs.splice(index, 1);
      }
      this.showDuration = false;
    },
    sendResult() {
      this.show = false;
      let result = [];
      for (let i = 0; i < this.selectedFahrs.length; i++) {
        let fahrAccess = this.selectedFahrs[i];
        let duration = this.durations[fahrAccess];
        result.push({
          access: fahrAccess,
          duration: duration
        });
      }
      this.$emit('save', result);
    }
  }



}
</script>

<style scoped>
::v-deep .v-list-item__content {
  padding: 0px 0;
}

::v-deep .v-list-item {
  min-height: 34px;
}

::v-deep .v-subheader {
  height: 24px;
  font-weight: 500;
}

::v-deep .v-divider {
  margin-bottom: 6px;
  margin-top: 6px;
}

</style>
